module.exports = __webpack_public_path__ + "img/login.acffda8c.png";